(function () {
  'use strict';
  var CM = window.CM || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  // Money in cents, formatted with the store's own money format
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    var fmt = CM.money || '${{amount}}';
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]).replace(/\{\{\s*amount\s*\}\}/, withCommas).replace(/<[^>]*>/g, '');
  }
  function moneyShort(cents) { var t = money(cents); return /\.00$/.test(t) ? t.slice(0, -3) : t; }
  function freeNote(cents) {
    return cents >= CM.free ? 'Your order ships free in the US.' : 'Add ' + money(CM.free - cents) + ' more for free US shipping.';
  }

  // ---------- Toast ----------
  var toastT;
  function toast(t) {
    var el = $('#toast'); if (!el) return;
    el.textContent = t; el.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(function () { el.classList.remove('show'); }, 2600);
  }

  // ---------- Cart drawer (Shopify AJAX cart) ----------
  var cartState = null, cartSeq = 0;
  // A read that started before a later change comes back as null and is not drawn
  function getCart() {
    var n = ++cartSeq;
    return fetch(CM.cartUrl + '.js?t=' + Date.now(), { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return n === cartSeq ? cart : null; });
  }
  function renderCart(cart) {
    if (!cart) return;
    cartState = cart;
    var count = $('#bagCount'); if (count) count.textContent = cart.item_count;
    var sub = $('#subtotal'); if (sub) sub.textContent = money(cart.total_price);
    var ft = $('#freeText'), ff = $('#freeFill');
    if (ft) ft.textContent = cart.total_price >= CM.free ? 'Your order ships free.' : 'Add ' + money(CM.free - cart.total_price) + ' more for free US shipping.';
    if (ff) ff.style.transform = 'scaleX(' + Math.min(1, cart.total_price / CM.free).toFixed(4) + ')';
    var L = $('#lines'); if (!L) return;
    if (!cart.items.length) { L.innerHTML = '<p class="empty">Your bag is empty. Pick a strength to start.</p>'; }
    else {
      L.innerHTML = cart.items.map(function (it) {
        var img = it.image ? '<img src="' + it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" width="64" height="64">' : '<span></span>';
        return '<div class="line-item">' + img + '<div><b>' + it.product_title + '</b><small>' + money(it.final_line_price) + '</small></div>' +
          '<div class="qty"><button type="button" data-key="' + it.key + '" data-step="-1" aria-label="Remove one ' + esc(it.product_title) + '">−</button><output aria-label="Quantity of ' + esc(it.product_title) + '">' + it.quantity + '</output>' +
          '<button type="button" data-key="' + it.key + '" data-step="1" aria-label="Add one ' + esc(it.product_title) + '">+</button></div></div>';
      }).join('');
    }
    setCheckoutState();
    renderSetNudge(cart);
    updateShipNotes();
    autoApplySet(cart);
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
  function refreshCart() { return getCart().then(renderCart).catch(function () {}); }

  // ---------- Checkout is held while the bag is being changed ----------
  var busy = false;
  function setCheckoutState() {
    var empty = !cartState || !cartState.items.length;
    var hold = busy || (cartState && groupsIn(cartState) > 0 && cartKey(cartState) !== failedKey);
    $$('#checkout, .cart-page [name="checkout"]').forEach(function (c) {
      c.classList.toggle('disabled', empty || hold);
      c.setAttribute('aria-disabled', (empty || hold) ? 'true' : 'false');
      if (hold) c.setAttribute('data-wait', ''); else c.removeAttribute('data-wait');
      if (c.tagName === 'BUTTON') c.disabled = !!hold;
    });
    var sn = $('#savingNote'); if (sn && !hold) sn.hidden = true;
  }
  function setBusy(on) { busy = on; setCheckoutState(); }

  // ---------- 20% off all three: applied automatically ----------
  // Adds the set first and only then takes one of each jar out, so a failure never loses a jar.
  var failedKey = '';
  function groupsIn(cart) {
    var J = CM.jars || []; if (!CM.set || J.length !== 3) return 0;
    return Math.min.apply(null, J.map(function (j) { return qtyOf(cart, j.variant); }));
  }
  function cartKey(cart) { return cart.items.map(function (i) { return i.variant_id + ':' + i.quantity; }).join(','); }
  function applySet(cart) {
    var n = groupsIn(cart); if (!n || busy) return Promise.resolve(false);
    var key = cartKey(cart);
    setBusy(true);
    var txt = $('#setNudgeText'); if (txt) { txt.textContent = 'Applying your ' + CM.set.off + '% discount…'; $('#setNudge').hidden = false; }
    var post = function (url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw new Error('rejected'); return r.json(); });
    };
    return post(CM.cartAdd + '.js', { items: [{ id: CM.set.variant, quantity: n }] })
      .then(function () {
        var updates = {};
        (CM.jars || []).forEach(function (j) { updates[j.variant] = qtyOf(cart, j.variant) - n; });
        return post(CM.cartUrl + '/update.js', { updates: updates }).catch(function (e) {
          // Put the bag back as it was: take the added set out again
          var undo = {}; undo[CM.set.variant] = qtyOf(cart, CM.set.variant);
          return post(CM.cartUrl + '/update.js', { updates: undo }).catch(function () {}).then(function () { throw e; });
        });
      })
      .then(function () { toast('Your three jars are now the Three-Strength Set, at 20% off.'); return true; })
      .catch(function () { failedKey = key; toast('We couldn’t apply the 20% discount. Your jars are unchanged.'); return false; })
      .then(function (ok) { setBusy(false); return getCart().then(function (c) { renderCart(c); return ok; }); });
  }
  function autoApplySet(cart) {
    if (busy || !groupsIn(cart) || cartKey(cart) === failedKey) return;
    applySet(cart).then(function (ok) { if (ok && document.querySelector('.cart-page')) location.reload(); });
  }
  // Checkout waits for the saving, from the bag and from the cart page
  document.addEventListener('click', function (e) {
    var c = e.target.closest('#checkout, .cart-page [name="checkout"]'); if (!c) return;
    if (busy || !cartState || !cartState.items.length) { e.preventDefault(); return; }
    if (cartState && groupsIn(cartState) && cartKey(cartState) !== failedKey) {
      e.preventDefault();
      applySet(cartState).then(function () { location.href = '/checkout'; });
    }
  }, true);

  // ---------- Three-strength set reminder in the bag ----------
  function qtyOf(cart, variant) {
    var n = 0; cart.items.forEach(function (it) { if (it.variant_id === variant) n += it.quantity; }); return n;
  }
  function andList(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1]; }
  function renderSetNudge(cart) {
    var box = $('#setNudge'), txt = $('#setNudgeText'); if (!box || !txt) return;
    var S = CM.set, J = CM.jars || [];
    var held = J.filter(function (j) { return qtyOf(cart, j.variant) > 0; });
    if (!S || J.length !== 3 || !held.length || qtyOf(cart, S.variant) > 0) { box.hidden = true; return; }
    if (held.length === 3) {
      var full = 0; J.forEach(function (j) { full += j.price; });
      txt.textContent = 'You’ve picked all three strengths. Together, they’re ' + S.off + '% off.';
      $('#setSwitch').textContent = 'Save ' + money(full - S.price);
    } else {
      var have = 0; held.forEach(function (j) { have += j.price; });
      var missing = J.filter(function (j) { return held.indexOf(j) < 0; }).map(function (j) { return j.name; });
      txt.textContent = 'Add ' + andList(missing) + ' for ' + money(S.price - have) + ' more and save ' + S.off + '% on all three.';
      $('#setSwitch').textContent = missing.length === 1 ? 'Add ' + missing[0] : 'Add both';
    }
    var tick = '<svg viewBox="0 0 12 12" width="11" height="11"><path d="M2 6.5l2.6 2.5L10 3.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var plus = '<svg viewBox="0 0 12 12" width="11" height="11"><path d="M6 2v8M2 6h8" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/></svg>';
    var jars = $('#snJars');
    if (jars) jars.innerHTML = J.map(function (j) {
      var isIn = held.indexOf(j) > -1;
      return '<figure class="sn-jar ' + (isIn ? 'sn-in' : 'sn-out') + '"><img src="' + j.img + '" alt="" width="200" height="278"><span class="sn-badge" aria-hidden="true">' + (isIn ? tick : plus) + '</span><figcaption>' + j.name + '</figcaption></figure>';
    }).join('');
    box.hidden = false;
  }
  var setSwitch = $('#setSwitch');
  if (setSwitch) setSwitch.addEventListener('click', function () {
    if (!cartState || !CM.set || busy) return;
    var missing = (CM.jars || []).filter(function (j) { return qtyOf(cartState, j.variant) === 0; });
    if (!missing.length) { applySet(cartState); return; }
    setSwitch.disabled = true;
    addItems(missing.map(function (j) { return { id: j.variant, quantity: 1 }; })).then(function () { setSwitch.disabled = false; });
  });
  var bagOpener = null;
  function openBag() {
    var b = $('#bag'); if (!b) return;
    if (!b.classList.contains('open')) {
      bagOpener = document.activeElement;
      // The cart may have changed in another tab or before a Back press
      if (!busy) refreshCart();
    }
    b.removeAttribute('inert'); b.classList.add('open'); $('#scrim').classList.add('open');
    var x = $('#closeBag'); if (x) x.focus();
  }
  function closeBag() {
    var b = $('#bag'); if (!b) return;
    b.classList.remove('open'); $('#scrim').classList.remove('open'); b.setAttribute('inert', '');
    var o = (bagOpener && document.body.contains(bagOpener)) ? bagOpener : $('#openBag'); if (o) o.focus();
  }
  // Keep keyboard focus inside the open bag
  document.addEventListener('keydown', function (e) {
    var b = $('#bag'); if (e.key !== 'Tab' || !b || !b.classList.contains('open')) return;
    var f = $$('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])', b).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (!b.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  function addItems(items) {
    return fetch(CM.cartAdd + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'We couldn’t add that to your bag.'); });
      return getCart();
    }).then(function (cart) { renderCart(cart); openBag(); })
      .catch(function (e) { toast(e.message || 'We couldn’t add that to your bag. Please try again.'); return refreshCart(); });
  }
  window.CMaddItems = addItems;

  var openBtn = $('#openBag');
  if (openBtn) openBtn.addEventListener('click', function (e) { e.preventDefault(); openBag(); });
  var closeBtn = $('#closeBag'); if (closeBtn) closeBtn.addEventListener('click', closeBag);
  var scrim = $('#scrim'); if (scrim) scrim.addEventListener('click', closeBag);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && $('#bag') && $('#bag').classList.contains('open')) closeBag(); });
  // Each tap changes the number on screen at once. The bag sends the final number
  // once the taps stop, and draws the bag from Shopify's answer to that change.
  var lines = $('#lines'), pendingQty = {}, sendTimer = null, sending = false, lastStep = null;
  if (lines) lines.addEventListener('click', function (e) {
    var b = e.target.closest('button[data-key]'); if (!b) return;
    var out = b.parentNode.querySelector('output');
    var q = Math.max(0, Math.min(99, Number(out.textContent) + Number(b.dataset.step)));
    out.textContent = q;
    pendingQty[b.dataset.key] = q;
    lastStep = { key: b.dataset.key, step: b.dataset.step };
    cartSeq++;
    setBusy(true);
    clearTimeout(sendTimer); sendTimer = setTimeout(sendQty, 350);
  });
  function sendQty() {
    if (sending) { sendTimer = setTimeout(sendQty, 150); return; }
    var keys = Object.keys(pendingQty);
    if (!keys.length) { setBusy(false); return; }
    var key = keys[0], q = pendingQty[key]; delete pendingQty[key];
    sending = true; cartSeq++;
    fetch(CM.cartChange + '.js', { method: 'POST', cache: 'no-store', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: q }) })
      .then(function (r) { if (!r.ok) throw new Error('rejected'); return r.json(); })
      .then(function (cart) {
        sending = false;
        if (Object.keys(pendingQty).length) { sendQty(); return; }
        setBusy(false);
        renderCart(cart);
        // Keep keyboard focus on the button that was pressed, or on the bag if the line is gone
        var again = lastStep && $$('#lines button[data-key]').filter(function (x) { return x.dataset.key === lastStep.key && x.dataset.step === lastStep.step; })[0];
        if (lines.contains(document.activeElement) || document.activeElement === document.body) (again || $('#closeBag')).focus();
      })
      .catch(function () {
        sending = false; pendingQty = {};
        toast('We couldn’t update your bag. Please try again.');
        setBusy(false); refreshCart();
      });
  }
  refreshCart();
  // A page restored by the Back button keeps its old bag; read the cart again
  window.addEventListener('pageshow', function (e) { if (e.persisted && !busy) refreshCart(); });

  function cartTotal() { return cartState ? cartState.total_price : 0; }

  // ---------- Homepage strength picker ----------
  var P = window.CM_PRODUCTS || [];
  var picker = $('#picker');
  var sel = null, qty = 1, view = 'jar';
  function byHandle(h) { for (var i = 0; i < P.length; i++) if (P[i].handle === h) return P[i]; return P[0]; }
  function base() { return P[0]; }

  function updateShipNotes() {
    var sn = $('#shipNote'); if (sn && sel) sn.textContent = freeNote(cartTotal() + sel.price * qty);
    var ps = $('#pdpShip'); if (ps) { var qn = $('#pdpForm input[name="quantity"]'); ps.textContent = freeNote(cartTotal() + Number(ps.dataset.price || 0) * Math.max(1, Number(qn ? qn.value : 1) || 1)); }
  }
  function renderPick() {
    if (!sel) return;
    $('#qVal').textContent = qty;
    $('#qMinus').setAttribute('aria-label', 'Remove one ' + sel.name + ' jar'); $('#qPlus').setAttribute('aria-label', 'Add one ' + sel.name + ' jar');
    var add = $('#addBtn');
    add.textContent = sel.available ? 'Add to bag · ' + money(sel.price * qty) : (window.CM.us ? 'Sold out' : window.CM.usOnly);
    add.disabled = !sel.available;
    updateShipNotes();
  }
  function showImg(im, p) {
    if (view === 'jar') { im.srcset = p.jar_xs + ' 300w, ' + p.jar_s + ' 400w, ' + p.jar + ' 600w'; im.src = p.jar; }
    else { im.removeAttribute('srcset'); im.src = p.lid; }
  }
  function select(p) {
    sel = p; qty = 1;
    $$('#tabs .tab').forEach(function (t) { t.setAttribute('aria-selected', t.dataset.handle === p.handle ? 'true' : 'false'); });
    picker.style.setProperty('--sel', p.color);
    var sb = $('#stickybuy'); if (sb) sb.style.setProperty('--sel', p.color);
    $('#bigMgo').textContent = p.mgo + '+';
    var im = $('#stageImg'); im.style.opacity = 0;
    setTimeout(function () { showImg(im, p); im.alt = 'Caramanuka Manuka Honey ' + p.name + ', 8.8 oz jar'; im.style.opacity = 1; }, 160);
    $('#dTier').textContent = p.tier; $('#dName').textContent = p.name;
    $('#dUse').textContent = p.use.replace('%DIFF%', moneyShort(p.price - base().price));
    $('#dTaste').innerHTML = '';
    $('#dTaste').appendChild(document.createTextNode(p.taste + ' '));
    var dots = document.createElement('span'); dots.className = 'taste-dots'; dots.setAttribute('role', 'img'); dots.setAttribute('aria-label', 'Strength of flavor ' + p.dots + ' of 5');
    for (var i = 1; i <= 5; i++) { var d = document.createElement('i'); if (i <= p.dots) d.className = 'on'; dots.appendChild(d); }
    $('#dTaste').appendChild(dots);
    $('#dFor').textContent = p.best;
    $('#gFill').style.setProperty('--g', (p.mgo / 1500).toFixed(4));
    $('#dPrice').innerHTML = money(p.price) + '<small>per jar</small>';
    var ml = $('#moreLink'); if (ml) { ml.href = p.url; ml.textContent = 'About ' + p.name; }
    var sbn = $('#sbName'); if (sbn) sbn.innerHTML = p.name + ' · ' + money(p.price) + '<small>8.8 oz jar</small>';
    renderPick();
  }
  if (picker && P.length) {
    $$('#tabs .tab').forEach(function (t) { t.addEventListener('click', function () { select(byHandle(t.dataset.handle)); }); });
    $('#tabs').addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var i = P.indexOf(sel) + (e.key === 'ArrowRight' ? 1 : -1); var p = P[(i + P.length) % P.length];
      select(p); var tb = $('#tabs .tab[data-handle="' + p.handle + '"]'); if (tb) tb.focus();
    });
    $('#vJar').addEventListener('click', function () { view = 'jar'; this.setAttribute('aria-pressed', 'true'); $('#vLid').setAttribute('aria-pressed', 'false'); showImg($('#stageImg'), sel); });
    $('#vLid').addEventListener('click', function () { view = 'lid'; this.setAttribute('aria-pressed', 'true'); $('#vJar').setAttribute('aria-pressed', 'false'); showImg($('#stageImg'), sel); });
    $('#qMinus').addEventListener('click', function () { qty = Math.max(1, qty - 1); renderPick(); });
    $('#qPlus').addEventListener('click', function () { qty = Math.min(12, qty + 1); renderPick(); });
    $('#addBtn').addEventListener('click', function () { addItems([{ id: sel.variant, quantity: qty }]); });
    var sbAdd = $('#sbAdd'); if (sbAdd) sbAdd.addEventListener('click', function () { addItems([{ id: sel.variant, quantity: 1 }]); });
    select(byHandle(picker.dataset.default));

    // MGO value chart: honey and money needed for 10 mg of MGO, from live prices
    var spoon = function (c) { return '<svg viewBox="0 0 30 14" aria-hidden="true"><ellipse cx="7" cy="7" rx="6.5" ry="5" fill="' + c + '"/><rect x="12" y="5.6" width="17" height="2.8" rx="1.4" fill="' + c + '"/></svg>'; };
    var rows = $('#spoonRows');
    if (rows) rows.innerHTML = P.map(function (p) {
      var grams = 10 / p.mgo * 1000, tsp = grams / 7, cost = Math.round(grams / 250 * p.price);
      var n = Math.max(1, Math.round(tsp)), icons = '';
      for (var i = 0; i < n; i++) icons += spoon(p.color);
      return '<div class="spoon-row" style="--c:' + p.color + '"><b>' + p.mgo + '+</b><div class="icons" aria-label="about ' + n + (n === 1 ? ' teaspoon' : ' teaspoons') + '">' + icons +
        '<small>about ' + n + (n === 1 ? ' teaspoon' : ' teaspoons') + '</small></div><div class="cost">' + money(cost) + '<small>of honey</small></div></div>';
    }).join('');
    var perMg = function (p) { return p.price / (p.mgo * 0.25); };
    var better = P.slice(1).filter(function (p) { return perMg(p) < perMg(P[0]); }).map(function (p) { return p.name; });
    var vl = $('#valueLine');
    if (vl) vl.textContent = better.length ? '. At our current prices, ' + better.join(' and ') + (better.length > 1 ? ' cost' : ' costs') + ' less per milligram of MGO than ' + P[0].name : '';

    // Sticky add-to-bag bar on phones once the picker scrolls past
    var sb2 = $('#stickybuy');
    if (sb2 && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (en) { sb2.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0); }); }).observe(picker);
    }
  }

  // Tools for AI shopping agents (WebMCP); ignored by browsers without it
  try {
    var mc = navigator.modelContext;
    if (mc && P.length) {
      var tools = [
        { name: 'list_caramanuka_products', description: 'List the Caramanuka Manuka honey strengths with MGO, price in USD, taste and availability.',
          inputSchema: { type: 'object', properties: {} },
          execute: function () { return { content: [{ type: 'text', text: JSON.stringify(P.map(function (p) { return { handle: p.handle, name: p.name, mgo: p.mgo, price_usd: p.price / 100, taste: p.taste, best_for: p.best, available: p.available, url: location.origin + p.url }; })) }] }; } },
        { name: 'add_caramanuka_to_bag', description: 'Add a Caramanuka strength to the shopping bag.',
          inputSchema: { type: 'object', properties: { handle: { type: 'string', enum: P.map(function (p) { return p.handle; }) }, quantity: { type: 'integer', minimum: 1, maximum: 12 } }, required: ['handle'] },
          execute: function (a) { var p = byHandle(a.handle); return addItems([{ id: p.variant, quantity: a.quantity || 1 }]).then(function () { return { content: [{ type: 'text', text: 'Added ' + (a.quantity || 1) + ' x ' + p.name + ' to the bag.' }] }; }); } }
      ];
      if (mc.provideContext) mc.provideContext({ tools: tools });
      else if (mc.registerTool) tools.forEach(function (t) { mc.registerTool(t); });
    }
  } catch (e) {}

  // Three-strength set
  var trio = $('#addTrio');
  if (trio) trio.addEventListener('click', function () { addItems([{ id: Number(trio.dataset.variant), quantity: 1 }]); });

  // ---------- Product page ----------
  var form = $('#pdpForm');
  if (form) {
    var qi = form.querySelector('input[name="quantity"]');
    $$('[data-q]', form).forEach(function (b) {
      b.addEventListener('click', function () { qi.value = Math.min(12, Math.max(1, Number(qi.value || 1) + Number(b.dataset.q))); updateShipNotes(); });
    });
    qi.addEventListener('input', updateShipNotes);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addItems([{ id: Number(form.querySelector('input[name="id"]').value), quantity: Number(qi.value || 1) }]);
    });
    var use = $('.pdp .use[data-use]');
    if (use && P.length === 0) { /* product page has no picker data; keep server text */ }
  }
  var gMain = $('#gMain'), zoomBtn = $('#gZoom'), zoom = $('#zoom'), zoomImg = $('#zoomImg');
  $$('.g-thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!gMain) return;
      gMain.src = t.dataset.src; gMain.srcset = t.dataset.srcset; gMain.alt = t.dataset.alt || gMain.alt;
      if (zoomBtn) { zoomBtn.dataset.full = t.dataset.full; zoomBtn.dataset.alt = t.dataset.alt || ''; }
      $$('.g-thumb').forEach(function (o) { o.removeAttribute('aria-current'); }); t.setAttribute('aria-current', 'true');
    });
  });
  if (zoomBtn && zoom && zoomImg && zoom.showModal) {
    zoomBtn.addEventListener('click', function () {
      zoomImg.src = zoomBtn.dataset.full; zoomImg.alt = zoomBtn.dataset.alt || ''; zoom.classList.remove('big');
      zoom.showModal();
    });
    // Tap zooms in on the spot that was tapped; tap again to fit the screen
    zoomImg.addEventListener('click', function (e) {
      if (zoom.classList.contains('big')) { zoom.classList.remove('big'); return; }
      var cw = zoomImg.clientWidth, ch = zoomImg.clientHeight, nw = zoomImg.naturalWidth || cw, nh = zoomImg.naturalHeight || ch;
      var sc = Math.min(cw / nw, ch / nh), w = nw * sc, h = nh * sc;
      var rx = Math.min(1, Math.max(0, (e.offsetX - (cw - w) / 2) / w)), ry = Math.min(1, Math.max(0, (e.offsetY - (ch - h) / 2) / h));
      zoom.classList.add('big');
      zoom.scrollLeft = rx * zoomImg.clientWidth - zoom.clientWidth / 2;
      zoom.scrollTop = ry * zoomImg.clientHeight - zoom.clientHeight / 2;
    });
    $('#zoomClose').addEventListener('click', function () { zoom.close(); });
    zoom.addEventListener('close', function () { zoomBtn.focus(); });
  }

  // ---------- Batch report form: name the button for what it does ----------
  if (document.querySelector('.globo-formbuilder')) {
    var label = '<span class="spinner"></span>Request my batch report';
    var nameBtn = function () {
      var b = document.querySelector('.globo-form-app .action.submit'); if (!b) return false;
      b.setAttribute('data-submit-text', label);
      if (/Submit/.test(b.textContent)) b.innerHTML = label;
      return true;
    };
    nameBtn();
    // The form app redraws its button after loading, so keep naming it for a while
    var mo = new MutationObserver(nameBtn);
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }
})();
